// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-xxlarge-text-fc9f783e"};